import { z } from "zod";
import { Timestamp } from "./primitives";
import { ProfileSummary } from "./profile";

/**
 * Where the current user stands with one other profile, from the user's side.
 * Derived from the caller's `friendships` row, the `friend_requests` row
 * between the two users, or the absence of both.
 */
export const Relationship = z.enum(["self", "none", "outgoing", "incoming", "friends"]).meta({
  id: "Relationship",
  description:
    "The current user's relationship to a profile. `self`: the profile is the caller's own. `none`: no request or friendship exists. `outgoing`: the caller sent a request that is still pending. `incoming`: the profile sent the caller a request that is still pending. `friends`: an accepted friendship exists.",
  example: "none",
});
export type Relationship = z.infer<typeof Relationship>;

export const FriendListEntry = z
  .strictObject({
    profile: ProfileSummary,
    since: Timestamp.meta({
      description:
        "When this entry came to be: the acceptance time for a friend, or the request time for a pending request.",
      example: "2026-09-10T14:32:00.000Z",
    }),
  })
  .meta({
    id: "FriendListEntry",
    description: "One row in a friends, received, or sent list.",
    example: {
      profile: {
        profileId: "0199f0be-4d1a-7b55-8c71-59a0d2e6c884",
        username: "Grace_Hopper",
        displayName: "Grace Hopper",
        avatar: null,
      },
      since: "2026-09-10T14:32:00.000Z",
    },
  });
export type FriendListEntry = z.infer<typeof FriendListEntry>;
